import { anniRegistrati } from '../apis/sharedApi';

export const getAnniRegistrati = () => dispatch => dispatch({ type: 'ANNI_REGISTRATI_GET', payload: anniRegistrati() });

export const setAnniRegistrati = anni => dispatch => dispatch({ type: 'ANNI_REGISTRATI_SET', payload: anni });

export const setAnnoSelezionato = anno => dispatch => dispatch({ type: 'ANNO_SELEZIONATO_SET', payload: anno });
